import { useEffect, useState } from "react";
import NavigationTabs from "../../utils/components/NavigationTabs";
import TasksList from "./components/TasksList";
import Breadcrumbs from "../../utils/components/Breadcrumbs";
import Button from "../../utils/components/Button";
import Modal from "../../utils/components/Modal";
import Loading from "../../utils/components/Loading";
import { MdOutlineArrowForwardIos, MdLocationOn } from "react-icons/md";
import SelectBox from "../../utils/components/SelectBox";
import { BiFilterAlt } from "react-icons/bi";
import { useProject } from "../../utils/hooks/useProject";
import API, { handleCancelRequest } from "../../utils/API";
import Input from "../../utils/components/Input";
import { AiOutlineSearch } from "react-icons/ai";

const SEARCH_TIMEOUT = 400;
const Tasks = ({ user, translate }) => {
  const [tasks, setTasks] = useState([]);
  const [activeTab, setActiveTab] = useState(translate("tasks.my_tasks"));
  const [siteSetId, setSiteSetId] = useState(null);
  const [siteSetDetailId, setSiteSetDetailId] = useState(null);
  const [locationSet, setLocationSet] = useState([]);
  const [locationSetRoot, setLocationSetRoot] = useState(null);
  const [selectedLocationSet, setSelectedLocationSet] = useState([]);
  const [allSiteSets, setAllSiteSets] = useState([]);
  const [viewNext, setViewNext] = useState(false);
  const [modal, setModal] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [query, setQuery] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [perPage, setPerPage] = useState(
    localStorage.getItem("tasks-per-page")
      ? parseInt(localStorage.getItem("tasks-per-page"))
      : 10
  );
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    templates: [],
    statuses: [],
    created_by: [],
    form_status: [],
  });
  const [selectedFilters, setSelectedFilters] = useState({
    templates: [],
    statuses: [],
  });

  const [selectedQuickFilters, setSelectedQuickFilters] = useState({
    created_by: [],
    form_status: [],
  });
  const [isLoadingSiteSetDetails, setIsLoadingSiteSetDetails] = useState(false);
  const [isTasksLoading, setIsTasksLoading] = useState(true);

  const [isProjectControl, setIsProjectControl] = useState(true);

  const { project } = useProject();

  const handleFormTemplateChange = (templates) => {
    setSelectedFilters({
      ...selectedFilters,
      templates,
    });
  };

  const handleStatusChange = (statuses) => {
    setSelectedFilters({
      ...selectedFilters,
      statuses,
    });
  };

  const selectedLocationSetHandler = (index) => {
    let parentId = null;
    let newSelectedLocationSet = [];

    if (index > 0) {
      parentId = selectedLocationSet[index - 1].id;
      newSelectedLocationSet = selectedLocationSet.slice(0, index);
      getSiteSetDetailByID(parentId);
    } else if (index === 0) {
      parentId = locationSetRoot.value;
      newSelectedLocationSet = [];
      getSiteSetByID(parentId);
    }
    setViewNext(true);
    setSelectedLocationSet(newSelectedLocationSet);
  };

  const allSiteSetsHandler = (siteSet) => {
    setLocationSetRoot(siteSet);
    getSiteSetByID(siteSet.value);
    setViewNext(true);
  };

  const getSiteSetByID = (id) => {
    setIsLoadingSiteSetDetails(true);
    setSelectedLocationSet([]);
    API.getData(`site_set/${id}`).then(({ data: res }) => {
      setLocationSet(res.data.details);
      setSiteSetId(res.data.id);
      setIsLoadingSiteSetDetails(false);
    });
  };

  const getSiteSetDetailByID = (id) => {
    setIsLoadingSiteSetDetails(true);
    API.getData(`site_set_detail/${id}`).then(({ data: res }) => {
      setLocationSet(res.data.details);
      setSiteSetDetailId(res.data.id);
      setIsLoadingSiteSetDetails(false);
    });
  };

  const setSiteSetDetailByID = (id) => {
    let siteSet = locationSet.find((item) => item.id === id);
    setSelectedLocationSet([...selectedLocationSet, siteSet]);

    if (!siteSet.is_details) {
      setViewNext(false);
    }
    getSiteSetDetailByID(id);
  };

  const getAllSiteSetsByProjectID = () => {
    if (project)
      API.getData(`site_sets?project_id=${project?.id}`).then(
        ({ data: res }) => {
          setAllSiteSets(res.data);
        }
      );
  };

  const getTaskFilterTable = () => {
    if (!project) return;

    let url = `tasks/filter_table?project_id=${project?.id}`;
    if (activeTab === translate("tasks.my_tasks")) {
      url += `&user_id=${user.id}`;
    }

    API.getData(url).then(({ data: res }) => {
      const filters = {
        templates: [],
        statuses: [],
        created_by: [],
        form_status: [],
      };

      filters.templates = res.data.templates?.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      filters.statuses = res.data.statuses?.map((item) => ({
        value: item.status,
        label: item.status,
      }));

      filters.created_by = res.data.created_by?.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      filters.form_status = res.data.form_status?.map((item) => ({
        value: item,
        label: item,
      }));

      setFilters(filters);
    });
  };

  useEffect(() => {
    getTaskFilterTable();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    getTasks(newPerPage, page);
    localStorage.setItem("tasks-per-page", newPerPage);
  };

  const handlePageChange = (page) => {
    setIsTasksLoading(true);
    getTasks(perPage, page);
  };

  const handleModal = () => {
    getTasks(perPage, 1);
    setModal(!modal);
    setIsLoading(true);
  };

  const determineTasksStatus = (tasks) => {
    let statusNo = 0;
    return tasks.map((task) => {
      if (task.color === "#a30909") {
        statusNo = 1;
      } else if (task.color === "#147103") {
        statusNo = 2;
      } else if (task.color === "#bc3a06") {
        statusNo = 3;
      } else {
        statusNo = 0;
      }

      return {
        ...task,
        statusNo,
      };
    });
  };

  const getTasks = (newPerPage, page) => {
    if (!project) return;
    handleCancelRequest();

    let payload = {
      site_set_id: siteSetId,
      site_set_detail_id: siteSetDetailId,
      templates: selectedFilters.templates.map((item) => item.value),
      statuses: selectedFilters.statuses.map((item) => item.value),
      created_bys: selectedQuickFilters.created_by.map((item) => item.value),
      form_status: selectedQuickFilters.form_status.map((item) => item.value),
    };
    let url = "tasks/filters?";
    url += project?.id ? `project_id=${project?.id}&` : "";
    url += page ? `page=${page}&` : "";
    url += newPerPage ? `size=${newPerPage}&` : "";
    url += query ? `search=${query}&` : "";

    if (activeTab === translate("tasks.my_tasks")) {
      url += `user_id=${user.id}`;
    }

    API.postData(url, payload)
      .then(({ data: res }) => {
        const tasksList = determineTasksStatus(res.data);
        setTasks(tasksList);

        setPerPage(newPerPage);
        setTotalRows(res.pagination.total_count);
        setIsLoading(false);
        setIsTasksLoading(false);
      })
      .catch(() => {
        setTasks([]);
        setIsTasksLoading(false);
        setIsLoading(false);
      });
  };

  const handleSearch = (e) => {
    const query = e.target.value;

    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearchTimeout(
      setTimeout(() => {
        setQuery(query);
      }, SEARCH_TIMEOUT)
    );
  };

  const handleSelectedFilters = (value, key) => {
    setSelectedQuickFilters({
      ...selectedQuickFilters,
      [key]: value,
    });
  };

  useEffect(() => {
    setPerPage(10);
    setTotalRows(0);
    if (project) {
      setIsLoading(false);
      getTasks(perPage, 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, query, selectedQuickFilters]);

  useEffect(() => {
    if (project) {
      setIsProjectControl(false);
      getTaskFilterTable();
      getAllSiteSetsByProjectID();
    } else {
      setIsProjectControl(true);
      setIsTasksLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="Tasks container-fluid">
      <div className="d-flex align-items-center justify-content-between my-4">
        <Breadcrumbs
          data={[
            {
              id: 0,
              customTitle: project?.name || " ",
              route: "auth.projects",
            },
            { id: 1, title: "page_titles.tasks" },
          ]}
        />
        <div>
          <Button
            className="btn-secondary d-flex align-items-center px-4 fs-5"
            onClick={() => setModal(true)}
          >
            <BiFilterAlt className="fs-5 me-2 mb-1" />
            <span>{translate("filter")}</span>
          </Button>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row bg-white p-3">
          <div className="col-12 col-md-3">
            <Input
              placeholder={translate("forms.place-holders.search-form-name")}
              onChange={handleSearch}
              iconNode={<AiOutlineSearch className="fs-5 me-2 mt-2" />}
            />
          </div>
          <div className="col-12 col-md-3 d-flex align-items-center">
            <SelectBox
              options={filters?.form_status || []}
              value={selectedQuickFilters.form_status}
              placeholder={translate("forms.place-holders.select-status")}
              onChange={(value) => handleSelectedFilters(value, "form_status")}
              width="100%"
              isClearable={true}
              isMulti={true}
              closeMenuOnSelect={false}
            />
          </div>
          <div className="col-12 col-md-3">
            <SelectBox
              options={filters?.created_by || []}
              value={selectedQuickFilters.created_by || []}
              onChange={(value) => handleSelectedFilters(value, "created_by")}
              placeholder={translate("forms.place-holders.select-created-by")}
              width="100%"
              isClearable={true}
              isMulti={true}
            />
          </div>
        </div>
      </div>

      {!isLoading && (
        <div className="bg-white py-2">
          <NavigationTabs
            tabs={[translate("tasks.my_tasks"), translate("tasks.all_tasks")]}
            activeTab={activeTab}
            onTabClick={(tab) => {
              setActiveTab(tab);
            }}
          />
        </div>
      )}
      <div>
        {isLoading ? (
          <Loading text="Loading" />
        ) : (
          <TasksList
            tasks={tasks}
            project={project}
            totalRows={totalRows}
            activeTab={activeTab}
            handlePerRowsChange={handlePerRowsChange}
            handlePageChange={handlePageChange}
            translate={translate}
            isTasksLoading={isTasksLoading}
            perPage={perPage}
          />
        )}
      </div>
      <div>
        <Modal
          title={translate("tasks.select_filters")}
          modalSize="xl"
          show={modal}
          setShow={(show) => setModal(show)}
          positiveButtonNode={translate("apply")}
          negativeButtonNode={translate("cancel")}
          positiveButtonHandler={() => {
            handleModal();
          }}
        >
          <div className="row mb-5 mt-3">
            <div className="col-12">
              <label className="form-label fw-bold pb-0">
                {translate("tasks.location_filter_title")}
              </label>
              <div className="col-12 py-2 bg-white shadow-sm rounded border-gray border">
                <div className="d-flex flex-wrap align-items-center">
                  <div className="d-flex flex-wrap align-items-center">
                    <div className="mx-2">
                      <SelectBox
                        options={allSiteSets?.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))}
                        value={locationSetRoot}
                        onChange={(e) => allSiteSetsHandler(e)}
                        placeholder={translate(
                          "tasks.location_filter_placeholder"
                        )}
                      />
                    </div>
                    {locationSetRoot && (
                      <div
                        className="d-flex align-items-center py-1"
                        onClick={() => selectedLocationSetHandler(0)}
                      >
                        <MdLocationOn className="fs-2 text-orange" />
                        <p className="mb-0 ps-1 pe-2">
                          {locationSetRoot.label}
                        </p>
                      </div>
                    )}
                    {selectedLocationSet?.map((location, index) => (
                      <div
                        className="d-flex flex-wrap align-items-center"
                        key={index}
                        onClick={() => selectedLocationSetHandler(index)}
                      >
                        <MdOutlineArrowForwardIos />
                        <p className="mb-0 px-2">{location.name}</p>
                      </div>
                    ))}
                    {viewNext && (
                      <div className="d-flex flex-wrap align-items-center">
                        <MdOutlineArrowForwardIos className="me-2" />
                        <SelectBox
                          options={
                            locationSet?.map((item) => ({
                              value: item.id,
                              label: item.name,
                            })) || []
                          }
                          isMulti={false}
                          value={{}}
                          onChange={(e) => setSiteSetDetailByID(e.value)}
                          placeholder={
                            isLoadingSiteSetDetails
                              ? translate("loading")
                              : translate("tasks.location_filter_placeholder")
                          }
                          isDisabled={isLoadingSiteSetDetails}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              <label className="form-label fw-bold pb-0">
                {translate("tasks.form_type_filter_title")}
              </label>
              <SelectBox
                options={
                  filters.templates?.map(({ value, label }) => ({
                    value,
                    label,
                  })) || []
                }
                value={selectedFilters.templates}
                isMulti={true}
                onChange={(values) => handleFormTemplateChange(values)}
                placeholder={translate("tasks.form_type_filter_placeholder")}
              />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label fw-bold pb-0">
                {translate("tasks.task_status_filter_title")}
              </label>
              <SelectBox
                options={
                  filters.statuses?.map(({ value, label }) => ({
                    value,
                    label: translate(`dashboard.${label}`),
                  })) || []
                }
                value={selectedFilters.statuses}
                isMulti={true}
                onChange={(values) => handleStatusChange(values)}
                placeholder={translate("tasks.task_status_filter_placeholder")}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title={translate("alert")}
          modaSize="lg"
          show={isProjectControl && !isTasksLoading}
          setShow={setIsProjectControl}
        >
          <p className="fs-5 text-center mt-2">
            {translate("select_a_project_alert")}
          </p>
        </Modal>
      </div>
    </div>
  );
};
export default Tasks;
